import { api } from "@/redux/api";

import {
	CopywritingSettings,
	CopywritingSettingsSchema,
	EmailSignatureDefault,
	EmailSignatureDefaultSchema,
	SendDelayDefaults,
	SendDelayDefaultsSchema,
	UpsertCopywritingSettings,
} from "../../pages/Company/schema/copywritingSettings";

export const copywritingSettingsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getCopywritingSettings: builder.query<CopywritingSettings, void>({
			query: () => ({
				url: "copywriting-settings",
				responseSchema: CopywritingSettingsSchema,
			}),
			providesTags: ["CopywritingSettings"],
		}),

		// Any signed-in user may read it: the campaign builders do, and not every builder user holds
		// the copywriting-settings permission (a 403 query would send them to the error page).
		getSendDelayDefaults: builder.query<SendDelayDefaults, void>({
			query: () => ({
				url: "copywriting-settings/send-delay-defaults",
				responseSchema: SendDelayDefaultsSchema,
			}),
			providesTags: ["CopywritingSettings"],
		}),

		// Any signed-in user, like the delays: every email composer reads it (PREC-4401).
		getEmailSignatureDefault: builder.query<EmailSignatureDefault, void>({
			query: () => ({
				url: "copywriting-settings/email-signature-default",
				responseSchema: EmailSignatureDefaultSchema,
			}),
			providesTags: ["CopywritingSettings"],
		}),

		upsertCopywritingSettings: builder.mutation<CopywritingSettings, UpsertCopywritingSettings>({
			query: (body) => ({
				url: "copywriting-settings",
				method: "PUT",
				body,
				responseSchema: CopywritingSettingsSchema,
			}),
			invalidatesTags: ["CopywritingSettings"],
		}),

		patchCopywritingSettings: builder.mutation<
			CopywritingSettings,
			Partial<UpsertCopywritingSettings>
		>({
			query: (body) => ({
				url: "copywriting-settings",
				method: "PATCH",
				body,
				responseSchema: CopywritingSettingsSchema,
			}),
			invalidatesTags: ["CopywritingSettings"],
		}),
	}),
});

export const {
	useGetCopywritingSettingsQuery,
	useGetSendDelayDefaultsQuery,
	useGetEmailSignatureDefaultQuery,
	useUpsertCopywritingSettingsMutation,
	usePatchCopywritingSettingsMutation,
} = copywritingSettingsApi;
